import { application } from "./application"
import MobileMenuController from "./mobile_menu_controller"
import DropdownController from "./dropdown_controller"
import PrintController from "./print_controller"
import TocSpyController from "./toc_spy_controller"
import TocMobileController from "./toc_mobile_controller"
import ExpandController from "./expand_controller"

application.register("mobile-menu", MobileMenuController)
application.register("dropdown", DropdownController)
application.register("print", PrintController)
application.register("toc-spy", TocSpyController)
application.register("toc-mobile", TocMobileController)
application.register("expand", ExpandController)
